import type {
  StyleValue,
  StylesProp,
} from "@circle-react-shared/BuilderUI/StyleValue.types";
import { isRecord, isStyleValue } from "./typePredicates";

export interface StyleValueMap {
  [key: string]: StyleValue | StyleValueMap;
}

const extractNestedStyles = (value: unknown): StyleValue | StyleValueMap => {
  if (isStyleValue(value)) {
    return value;
  }

  if (isRecord(value)) {
    return Object.entries(value).reduce<StyleValueMap>(
      (acc, [key, nestedValue]) => {
        acc[key] = extractNestedStyles(nestedValue);
        return acc;
      },
      {},
    );
  }

  return {};
};

export const getExistingStyles = (parentProp: StylesProp) =>
  extractNestedStyles(parentProp.value);
